/* global Sys, Services */
Sys.ns("Services");

/**
 * The Paytable Service.
 *
 * @class Services.Paytable
 * @extends Services.Base
 */
Services.Paytable = {
    constructor: function() {
        Services.Paytable.superclass.constructor.apply(this, arguments);

        this._enabled = true;
        this._open = false;
        this._content = [];
        this._currentPage = null;
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:stateHandler.enteringSpinningState": this.close.bind(this),
            "notify:gameModeChanged": this.close.bind(this)
        });
    },

    /**
     * Enables the paytable (if not already enabled).
     *
     * @returns {void}
     */
    enable: function() {
        if (this._enabled) {
            return;
        }

        this._enabled = true;

        this.publish("enabled");
    },

    /**
     * Disables the paytable (if not already disabled).
     *
     * @returns {void}
     */
    disable: function() {
        if (!this._enabled) {
            return;
        }

        this._enabled = false;

        this.publish("disabled");
    },

    /**
     * Opens the paytable (if not already open, or the page number is different).
     *
     * @param {number} [page] The number of the page to open.
     * @returns {void}
     */
    open: function(page) {
        var currentPage = this.getCurrentPage(),
            pageNumber = this._isValidPageNumber(page) ? page : 1;

        this._currentPage = pageNumber;

        if (this._open && pageNumber === currentPage) {
            return;
        }

        this._open = true;

        this.publish("opened", pageNumber);
    },

    /**
     * Closes the paytable (if not already closed).
     *
     * @returns {void}
     */
    close: function() {
        if (!this._open) {
            return;
        }

        this._open = false;
        this._currentPage = null;
        this.publish("closed");
    },

    /**
     * Sets the content of the paytable.
     *
     * @param {string|string[]} content The content. A string for each page in the paytable.
     * @returns {void}
     */
    setContent: function(content) {
        var pages = content;

        if (typeof content === "string") {
            pages = [content];
        }

        this._content = pages;

        this.publish("contentChanged", this._content);
    },

    /**
     * Moves the paytable to the next page (if showing).
     * Rolls to the first page if the last page is currently being shown.
     *
     * @returns {void}
     */
    nextPage: function() {
        var startingPage = this._currentPage,
            numberOfPages = this.getNumberOfPages();

        if (this.isOpen() && numberOfPages > 1) {
            this._currentPage = this._currentPage + 1;

            if (this._currentPage > numberOfPages) {
                this._currentPage = 1;
            }

            this.publish("pageChanged", this._currentPage, startingPage, true);
        }
    },

    /**
     * Moves the paytable to the previous page (if showing).
     * Rolls to the last page if the first page is currently being shown.
     *
     * @returns {void}
     */
    previousPage: function() {
        var startingPage = this._currentPage,
            numberOfPages = this.getNumberOfPages();

        if (this.isOpen() && numberOfPages > 1) {
            this._currentPage = this._currentPage - 1;

            if (this._currentPage <= 0) {
                this._currentPage = numberOfPages;
            }

            this.publish("pageChanged", this._currentPage, startingPage, true);
        }
    },

    /**
     * Updates the page number when page is changed by bullet navigation.
     *
     * @param {number} [currnePage] The number of the current page.
     * @param {number} [previousPage] The number of the previous page.
     * @returns {void}
     */
    updatePageNumber: function(currnePage, previousPage) {
        this._currentPage = currnePage;
        this.publish("pageChanged", this._currentPage, previousPage, false);
    },

    /**
     * Gets the number of pages in the paytable.
     *
     * @returns {number} The number of pages.
     */
    getNumberOfPages: function() {
        return this._content.length;
    },

    /**
     * Gets the current page index.
     *
     * @returns {number} The current page index.
     */
    getCurrentPage: function() {
        return this._currentPage;
    },

    /**
     * Gets the paytable content.
     *
     * @returns {string[]} The paytable content separated as pages.
     */
    getContent: function() {
        return this._content;
    },

    /**
     * Checks if the paytable is enabled.
     *
     * @returns {boolean} Whether or not the paytable is enabled.
     */
    isEnabled: function() {
        return this._enabled;
    },

    /**
     * Checks if the paytable is currently being shown.
     *
     * @returns {boolean} Whether or not the paytable is shown.
     */
    isOpen: function() {
        return this._open;
    },

    /**
     * Checks if the page number is valid (i.e. A number and in range).
     *
     * @private
     * @param {number} page The page number to validate.
     * @returns {boolean} Whether or not the page is a valid page number.
     */
    _isValidPageNumber: function(page) {
        return (
            typeof page === "number" &&
            !isNaN(page) &&
            page > 0 &&
            page <= this.getNumberOfPages()
        );
    }
};

Services.Paytable = Sys.extend(
    Services.Base,
    Services.Paytable,
    "Services.Paytable"
);
